module.exports = __webpack_public_path__ + "ab910d72bcd55b4fa11eb9410cc82a67.svg";